module.exports = __webpack_public_path__ + "static/media/logo_ucla.ca81904e.svg";